exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-export {\n\tposition: relative;\n}\n\n.header-export-list {\n\tposition: absolute;\n\tleft: -130px;\n\tz-index: 10;\n\tmin-width: 200px;\n\tbox-shadow: 0 3px 16px 0 rgba(0, 0, 0, 0.2);\n\tpadding: 12px;\n\tbackground: #fff;\n}\n\n.export-option {\n\tfont-weight: bold;\n\tfont-size: 12px;\n\tcolor: #444444;\n\topacity: 0.7;\n\ttext-align: left;\n\tline-height: 40px;\n\tcursor: pointer;\n}\n", ""]);

// exports
